import qs from "qs";
import md5 from "md5";

export default {
    install: function (Vue, options) {
        let tags = 'Track_V2';
        Vue.prototype.InitTrackV2 = function () {
            console.log(tags, 'InitTrack', options);
        }

        //统计方法
        Vue.prototype.TrackV2 = function (keyStr, key1, key2) {
            let self = this;
            const tims = (new Date().getTime() / 1000).toFixed(0);
            const u = navigator.userAgent;
            const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
            let language = (navigator.browserLanguage || navigator.language).toLowerCase();
            if (typeof key1 === 'undefined') {
                key1 = '';
            }
            if (typeof key2 === 'undefined') {
                key2 = '';
            }
            let request_data = [
                {
                    "product_id": self.$Request['product_id'],
                    "uuid": self.$Request['uuid'],
                    // "product_id": '210',
                    // "uuid": '213113123123',
                    "time_stamp": tims,
                    "package_name": "com.staaa",
                    "country": language,
                    "media_source": "other",
                    "campaign": "other_campaign",
                    "version_code": 1,
                    "version_name": "1.0",
                    "google_aid": "4567-8901-3344-5678",
                    "stats_sdk_version": "0.1",
                    "install_days": 1,
                    "is_upgrade_user": 1,
                    "process_uuid": "abc-efg-uvw-xyz-c",
                    "os": isiOS ? 2 : 1,
                    "os_version": "8.0",
                    "os_language": language,
                    "phone_model": "phone_model",
                    "net": "WIFI",
                    "memory": 2,
                    "dpi": 50,
                    "screen_wh": document.body.clientWidth + "x" + document.body.clientHeight,
                    "screen_inchu": "4.9",
                    "imei": "123456789",
                    "imsi": "987654321",
                    "src": 513,
                    "event": keyStr,
                    "eb_key1": key1,
                    "eb_key2": key2,
                }
            ];
            if (keyStr == 'show_apkweb') {
                request_data[0]["productID"] = self.json.product_id;
                request_data[0]["userID"] = self.json.uuid;
            }

            //签名加密c
            const key = 'L9gh=p%Eozfn2#@';
            const request_data_str = JSON.stringify(request_data);
            const sign = md5(key + request_data_str + key + tims + key);
            let obj = {
                request_data: request_data_str,
                timestamp: tims,
                sign: sign,
            }
            const url = 'https://n12.smartmobitec.com/service_stats/v3/collect';
            self.$axios.post(url, qs.stringify(obj))
                .then(function (response) {
                    let data = response.data;
                    if (data) {
                        console.log('统计成功', keyStr, key1, key2)
                    }
                })
                .catch(function (error) {
                    console.log(error.data);
                });
        }
        // ======================== 具体事件内容 ================================

    }
}

